"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceVersionUnsupported = void 0;
const errorBase_1 = require("./errorBase");
class DeviceVersionUnsupported extends errorBase_1.ErrorBase {
}
exports.DeviceVersionUnsupported = DeviceVersionUnsupported;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGV2aWNlVW5zdXBwb3J0ZWQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZXJyb3JzL2RldmljZVVuc3VwcG9ydGVkLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLDJDQUFxQztBQU1yQyxNQUFhLHdCQUF5QixTQUFRLHFCQUFTO0NBQUc7QUFBMUQsNERBQTBEIn0=